
import { Component, Vue } from 'vue-property-decorator'
import RacingCommentService from '@/biz/service/Comment/RacingCommentService'

@Component
export default class RacingCommentIndex extends Vue {
  private Service = RacingCommentService
}
